import { END_TIME } from './types';

export const endTime = () => ({
    type: END_TIME
});